import axios from "axios";
import { apiInstanceFetch } from "../../../util/api";
import * as ActionType from "./affiliateReels.type";
import { setToast } from "../../../util/toast";

export const getAffiliateReels = (start, limit) => (dispatch) => {
  apiInstanceFetch
    .get(`reel/getAffiliateReels?start=${start}&limit=${limit}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_AFFILIATE_REELS,
        payload: res.reels,
        totalReels: res.totalReels,
      });
    })
    .catch((error) => console.error(error));
};

export const deleteAffiliateReel = (id) => (dispatch) => {
  axios
    .delete(`reel/deleteReel?reelId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_AFFILIATE_REELS,
          payload: id,
        });
        setToast("success", "Reel deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};
